export enum CheckoutMode {
    Default = 'default',
    Cvv = 'cvv'
}